import { render } from "./FeedSelector.vue?vue&type=template&id=4c2e567e&scoped=true"
import script from "./FeedSelector.vue?vue&type=script&lang=js"
export * from "./FeedSelector.vue?vue&type=script&lang=js"

import "./FeedSelector.vue?vue&type=style&index=0&id=4c2e567e&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2e567e"]])

export default __exports__